import { gql } from '@apollo/client';

export function modifyBankersDetails() {
  return gql`
    mutation modifyBankersDetails(
      $entityId: String!
      $policyBankersBlanketBondInput: [Production_PolicyBankersBlanketBondInputs]
    ) {
      production {
        entities {
          policy {
            production {
              modifyBankersDetails(
                entityId: $entityId
                policyBankersBlanketBondInput: $policyBankersBlanketBondInput
              )
            }
          }
        }
      }
    }
  `;
}
